import { selectCaseIdData, selectCaseOverview, useAppSelector } from '@/store';
import { useMemo } from 'react';
import { CaseOverviewResponse } from '@/api';

type CaseOverviewCards = {
  fullBundleCard: CaseOverviewResponse['fullBundle'] | null;
  lightBundleCard: CaseOverviewResponse['lightBundle'] | null;
  timelineBundleCard: CaseOverviewResponse['timeline'] | null;
  chronologyBundleCard: CaseOverviewResponse['chronology'] | null;
};

export const useAiProcessedDocuments = () => {
  const caseId = useAppSelector(selectCaseIdData);
  const caseOverview = useAppSelector(selectCaseOverview);

  const caseOverviewCards: CaseOverviewCards = useMemo(() => {
    return {
      fullBundleCard: caseOverview?.fullBundle ?? null,
      lightBundleCard: caseOverview?.lightBundle ?? null,
      timelineBundleCard: caseOverview?.timeline ?? null,
      chronologyBundleCard: caseOverview?.chronology ?? null
    };
  }, [caseOverview]);

  return { caseId, caseOverviewCards };
};
